/*
  Avança automaticamente os carrosséis de "Ingredientes" (home e página de
  produto), sem precisar o usuário arrastar. Para de avançar sozinho assim
  que a pessoa interage manualmente (toque/arraste). Roda mesmo com "reduzir
  movimento" ativado — é só uma rotação de conteúdo, não o tipo de animação
  intensa que essa preferência normalmente visa evitar.
*/
(function () {
  // Os ids reais no HTML são "carousel-template--XXXX__<sufixo>" (Shopify
  // prefixa com o id do template, que varia por página). Por isso usamos um
  // seletor "termina com" pra cada seção conhecida, em vez do id completo.
  var CAROUSEL_ID_SUFFIXES = [
    '__b3578b09-ad00-41a1-9ab6-170460fdd2ba', // Ingredientes — página de produto
    '__ddba6143-922c-42c3-8f09-d578be1bb2cb' // Ingredientes — página inicial
  ];
  var ADVANCE_MS = 3500;

  function setupOne(carousel) {
    if (!carousel || carousel.dataset.autoplayReady) return;
    carousel.dataset.autoplayReady = 'true';

    var index = carousel.selectedIndex || 0;
    var timer = setInterval(function () {
      var total = carousel.items ? carousel.items.length : 0;
      if (!total) return;
      index = (index + 1) % total;
      carousel.select(index);
    }, ADVANCE_MS);

    // No celular, só considera "interação de verdade" quando é um arrasto
    // horizontal no carrossel (swipe) — um toque que na verdade é só a
    // pessoa rolando a página verticalmente não deve parar o avanço automático.
    var touchStartX = null;
    var touchStartY = null;

    carousel.addEventListener('touchstart', function (event) {
      var touch = event.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }, { passive: true });

    carousel.addEventListener('touchend', function (event) {
      if (touchStartX === null) return;
      var touch = event.changedTouches[0];
      var deltaX = Math.abs(touch.clientX - touchStartX);
      var deltaY = Math.abs(touch.clientY - touchStartY);
      touchStartX = null;
      touchStartY = null;
      if (deltaX > 15 && deltaX > deltaY) {
        clearInterval(timer);
      }
    }, { passive: true });

    // Desktop: arrastar com o mouse também para o avanço automático.
    carousel.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse') {
        clearInterval(timer);
      }
    }, { once: true, passive: true });
  }

  function setup() {
    CAROUSEL_ID_SUFFIXES.forEach(function (suffix) {
      setupOne(document.querySelector('[id$="' + suffix + '"]'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);
})();
